import React, {Fragment, PureComponent} from "react"
import PropTypes from "prop-types"

import id from "@irati/utils/id"
import {injectIntl, FormattedMessage} from "@irati/utils/lang"
import ReportListQuery from "@irati/insights/apollo/query/report/list"
import {ReportsContext} from "@irati/insights/context"
import {overrideAuth} from "@irati/insights/utils/apollo"

import {Card} from "../../ui/Layout"
import {ReactTable} from "../../ui/Table"
import {SectionTitle} from "../../components/Analysis"
import columns from "./columns"

const PAGE_SIZE = 6
const INSIGHTS_REPORT_TYPE = "insights-cycle"
const EXPORT_TYPE = "pdf"


class ReportList extends PureComponent {
  static propTypes = {
    formatMessage: PropTypes.func.isRequired
  }
  static defaultProps = {}


  constructor(props) {
    super(props)
    this.state = {
      page: 0
    }
  }

  resetPagination = () => {
    this.setState({page: 0})
  }

  render() {
    const idNamespace = id("ReportList", this.props, {force: true})
    const {formatMessage} = this.props
    const {page} = this.state

    return (
      <ReportsContext>
        {({isDemo, demoTenantAccessToken, tenantId}) => {
          const params = {
            offset: page * PAGE_SIZE,
            limit: PAGE_SIZE,
            reportType: INSIGHTS_REPORT_TYPE,
            exportType: EXPORT_TYPE
          }

          if (isDemo) {
            params.tenantUuid = tenantId
            params.userUuid = "demo" // @todo remove this hardcoded userUuid
          }

          return (
            <ReportListQuery variables={{params}} useLoader={false} {...overrideAuth(demoTenantAccessToken, isDemo)}>
              {({reports: {results = [], total = 0} = {}, loading}) => {
                const showTable = total || loading
                return (
                  <Fragment>
                    <SectionTitle
                      title={formatMessage({id: "insights.reports.list.title"})}
                      badgeCopy={formatMessage({id: "insights.reports.list.summary"}, {total})} />
                    <Card>
                      {showTable && (
                        <ReactTable
                          id={id("ReportList", idNamespace)}
                          data={results}
                          pages={Math.ceil(total / PAGE_SIZE)}
                          loading={loading}
                          page={page}
                          defaultPageSize={PAGE_SIZE}
                          showPagination={total > PAGE_SIZE}
                          columns={columns(formatMessage)}
                          onPageChange={(nextPage) => {
                            this.setState({page: nextPage})
                          }}
                          getPaginationProps={(props) => ({...props, shouldScrollOnUpdate: false})} />
                      )}
                      {!showTable && <FormattedMessage id="insights.reports.list.empty" />}
                    </Card>
                  </Fragment>
                )
              }}
            </ReportListQuery>
          )
        }}
      </ReportsContext>
    )
  }
}

export default injectIntl(ReportList, {withRef: true})
